import { hasTreatment } from '@/lib/features/utils';

// Experiments related to specific features

export const shouldShowOTP = (): boolean => {
  return hasTreatment('FEATURE_ONBOARDING_OTP');
};

export const suppressSignup = (): boolean => {
  const toggleSuppressRoW = hasTreatment(
    'FEATURE_EXISTING_EMAIL_SUPPRESS_SIGNUP',
  );

  return toggleSuppressRoW;
};
